import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';

import router from './routes';
import store from './store';

import socket from './socket';
import lang from '@tv/filters/lang';
import datetime from '@lc/filters/datetime';
import currency from '@tv/filters/currency';
import asset_version from '@tv/filters/asset_version';

import Default from './components/Default.vue';

import { syncFrameHeight } from "@tv/helpers";

import $ from "jquery";

import 'babel-polyfill';
import './icons';

import Axios from "axios";

Axios.defaults.headers.common['X-CSRF-TOKEN'] = Config.csrf_token;

Vue.use(BootstrapVue);

Vue.filter('asset_version', asset_version);
Vue.filter('currency', currency);
Vue.filter('lang', lang);
Vue.filter('datetime', datetime);

const data = {
    
};

new Vue({
    el: '#app',
    store, router, data,
    components: { Default },
});

router.afterEach(syncFrameHeight);
router.push({ name: 'lottery', params: { gameId: Config.game_id } });

store.commit('setPurchaseGameId', Config.game_id);
store.commit('updateBalance', Config.balance);
store.commit('updateWidth', window.innerWidth);

window.addEventListener('resize', () => {
    store.commit('updateWidth', window.innerWidth);
});

for (const ticket of Config.tickets.active) {
    store.commit('addTicket', { type: 'active', ticket, 'action': 'append' })
}

for (const ticket of Config.tickets.history) {
    store.commit('addTicket', { type: 'history', ticket, 'action': 'append' })
}

for (const [ gameId, game ] of Object.entries(Config.games)) {
    store.commit('updateAllowPurchase', { gameId, allow: game.allow_purchase, info: game.allow_purchase_info });
    for (const [ poolId, { amount } ] of Object.entries(game.pools)) {
        store.commit('updatePoolAmount', { poolId, amount });
    }
}

socket.on('channel', channel => {
    store.commit('updateChannel', channel);
});

socket.on('shop_game', shopGame => {
    store.commit('updateShopGame', shopGame);
});

socket.on('datetime', ({ datetime }) => {
    store.commit('updateDatetime', datetime);
});

socket.on('allowPurchase', ({ gameId, allow, info }) => {
    store.commit('updateAllowPurchase', { gameId, allow, info });
});

socket.on('addPayout', ({ balance, ticket }) => {
    store.commit('updateBalance', balance);
    store.commit('addTicket', { type: 'history', ticket, 'action': 'prepend' });
});

socket.on('removePayin', ({ ticket }) => {
    store.commit('removeTicket', { type: 'active', id: ticket });
});

socket.on('poolAmount', ({ pool_id, amount }) => {
    store.commit('updatePoolAmount', { poolId: pool_id, amount });
});

socket.on('playerMessage', ({ text, action }) => {
    const payload = { text };

    if (action === 'reload') {
        payload.callback = () => location.reload();
    }

    store.commit('setMessage', payload);
});

socket.on('connection', () => store.commit('setConnectionStatus', 'connected'));
socket.on('reconnection', () => store.commit('setConnectionStatus', 'connected'));

socket.on('reconnecting', () => store.commit('setConnectionStatus', 'connecting'));
socket.on('reconnecting', attempt => attempt > 5 && store.commit('setConnectionStatus', 'disconnected'));

socket.on('reload', () => {
    store.commit('setConnectionStatus', 'disconnected')
    socket.disconnect();
});

socket.on('logout', () => {
    store.commit('logout');
});

setInterval(() => store.commit('incrementDatetime'), 1000);

socket.on('live', ({ channel_id, type, stream_url }) => {
    if (type == 'start') {
        store.commit('addStream', { channelId: channel_id, url: stream_url });
    } else if (type == 'end_max') {
        store.commit('removeStream', channel_id);
    }
});

socket.on('live', ({ channel_id, type }) => {
    store.commit('updateChannelLive', { channel_id, type });
});

if (window.self != window.top) {
    $(window).on('resize', syncFrameHeight);
    $(syncFrameHeight);
}

if (window.finishGameLoader) {
    window.finishGameLoader(() => syncFrameHeight())
}